var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9463 0.794062C16.3682 0.311251 15.622 -0.0014691 14.7857 5.19017e-06H3.21429C1.45936 0.00964804 0.00415102 1.34959 0 3V9C0 10.6541 1.44198 12 3.21429 12H14.7857C16.558 12 18 10.6541 18 9V3C18 2.12466 17.5892 1.34304 16.9463 0.794062ZM14.7857 1.2C14.9813 1.2 15.1664 1.23536 15.3443 1.28612L8.99989 6.40669L2.65544 1.28612C2.83338 1.23536 3.01848 1.2 3.21407 1.2H14.7857ZM16.7143 9C16.7143 9.99254 15.8491 10.8 14.7857 10.8H3.21429C2.15085 10.8 1.28571 9.99254 1.28571 9V3C1.28571 2.63867 1.40281 2.30346 1.59983 2.02125L8.57942 7.65405C8.70053 7.75128 8.84991 7.7999 8.99999 7.7999C9.15008 7.7999 9.29946 7.75128 9.42057 7.65405L16.4002 2.02125C16.5972 2.30344 16.7143 2.63867 16.7143 3L16.7143 9Z",
    fill: "#96A8BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e116315e367ff257ea9e696db7bd9665.svg";
export { ForwardRef as ReactComponent };